/**
 * Podbarvení fotek produktů na produktové stránce.
 *
 * V gridu stačí poziční pravidlo v custom.css (hlavní fotka je v 97 % na bílém,
 * hover fotka v 91 % scéna). V galerii na produktovce to ale nevychází —
 * podíl bílých pozadí podle pořadí fotky je 97 / 9 / 58 / 92 / 95 %, takže
 * třetí pozice je půl na půl a poziční pravidlo by u ní pokaždé střelilo vedle.
 *
 * Proto se pozadí rozpozná z pixelů: stáhne se 40px náhled fotky, změří se
 * okrajové pixely a jen fotky s bílým okrajem dostanou .photo-bg--tinted.
 * Zbytek zůstane beze změny.
 *
 * Shopify CDN posílá access-control-allow-origin: *, takže je čtení plátna
 * povolené. Kdyby to přesto selhalo (tainted canvas, výpadek), fotka prostě
 * zůstane nepodbarvená — nikdy se nic nerozbije.
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('photo-bg')) return;

  var TINTED = 'photo-bg--tinted';
  var PROBE_WIDTH = 40;
  // Okrajový pixel se bere jako bílý od 245 výš; fotka projde, když je
  // takových aspoň 90 % okraje. Scénické fotky jsou výrazně tmavší,
  // takže je od bílých ořezů dělí velká mezera a práh není citlivý.
  var WHITE_MIN = 245;
  var WHITE_RATIO = 0.9;

  var cache = new Map();

  /**
   * Zmenšený náhled téže fotky — bez width/height/crop, ať sedí poměr stran.
   *
   * Storefront servíruje fotky ze same-origin cesty /cdn/shop/files/…, ne
   * z cdn.shopify.com (to vrací jen products.json). Pouštíme proto obě
   * podoby: cestu s /cdn/ na vlastní doméně i přímo doménu Shopify CDN.
   * U čehokoli jiného vrátíme null a fotka zůstane nepodbarvená.
   */
  function probeUrl(src) {
    try {
      var u = new URL(src, window.location.href);
      var isShopifyImage = u.pathname.indexOf('/cdn/') !== -1 || /(^|\.)shopify\.com$/.test(u.hostname);
      if (!isShopifyImage) return null;
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      u.searchParams.set('width', String(PROBE_WIDTH));
      return u.href;
    } catch (e) {
      return null;
    }
  }

  function hasWhiteBorder(img) {
    var c = document.createElement('canvas');
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    if (!c.width || !c.height) return false;

    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0);

    var data;
    try {
      data = ctx.getImageData(0, 0, c.width, c.height).data;
    } catch (e) {
      return false; // tainted canvas → radši nepodbarvovat
    }

    var white = 0;
    var total = 0;
    var at = function (x, y) {
      var i = (y * c.width + x) * 4;
      total++;
      if (data[i] >= WHITE_MIN && data[i + 1] >= WHITE_MIN && data[i + 2] >= WHITE_MIN) white++;
    };

    for (var x = 0; x < c.width; x++) {
      at(x, 0);
      at(x, c.height - 1);
    }
    for (var y = 1; y < c.height - 1; y++) {
      at(0, y);
      at(c.width - 1, y);
    }

    return total > 0 && white / total >= WHITE_RATIO;
  }

  function detect(src) {
    var url = probeUrl(src);
    if (!url) return Promise.resolve(false);
    // Klíč = normalizovaná URL náhledu, ne původní src: velká fotka, její
    // náhled v pásku (jiná width) i klony slidů od swiperu tak sdílejí
    // jediné měření místo tří.
    if (cache.has(url)) return cache.get(url);

    var p = new Promise(function (resolve) {
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        resolve(hasWhiteBorder(probe));
      };
      probe.onerror = function () {
        resolve(false);
      };
      probe.src = url;
    });

    cache.set(url, p);
    return p;
  }

  function apply(img) {
    var parent = img.parentElement;
    if (!parent || parent.dataset.photoBgChecked) return;

    var src = img.currentSrc || img.getAttribute('src');
    if (!src) {
      // Lazy fotka ještě nemá zdroj — zkusíme to znovu, až se načte.
      img.addEventListener('load', function () { apply(img); }, { once: true });
      return;
    }

    parent.dataset.photoBgChecked = '1';
    detect(src).then(function (isWhite) {
      // toggle, ne add: první fotka má třídu už z Liquidu (product-thumbnail.liquid),
      // a když se ukáže jako scéna, musí se zase odebrat.
      parent.classList.toggle(TINTED, isWhite);
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.product__media-gallery img').forEach(apply);
  }

  function init() {
    var gallery = document.querySelector('.product__media-gallery');
    if (!gallery) return;

    scan(gallery);

    // Přepnutí varianty galerii překreslí — nové fotky je potřeba doměřit.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          scan(gallery);
          return;
        }
      }
    }).observe(gallery, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
